export const getSalonInfo = async (salonId) => {
    let res = await fetch(`${process.env.PREACT_APP_API_URL}api/get-salon-info/${salonId}`, {mode: "cors"});
    res = await res.json();
    return res
}

export const sendVerification = async (phoneNumber) => {
    let response = await fetch(`${process.env.PREACT_APP_API_URL}api/send_verify_token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({phone_number: phoneNumber}),
    })
    const json = await response.json();
    if (response.status === 200 || response.status === 201) {
        return {
            responseCode: response.status,
            success: true,
            data: json,
        };
    }
}

export const verifyPhoneNumber = async (phone, code) => {
    const body = {
        phone_number: phone,
        code,
    };
    const response = await fetch(`${process.env.PREACT_APP_API_URL}api/verify_phone_number`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify(body),
    });
    const json = await response.json();
    if (response.status === 200 || response.status === 201) {
        return {
            responseCode: response.status,
            success: json.success,
            data: json,
        };
    } else {
        return {
            responseCode: response.status,
            success: false,
        };
    }
}

export const createBooking = async (stylistId, name, phoneNumber, service = null) => {
    const body = {
        stylist_id: stylistId,
        name,
        phone_number: phoneNumber,
        service
    }
    const response = await fetch(`${process.env.PREACT_APP_API_URL}api/website/bookings`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify(body),
    });

    const json = await response.json();
    if (response.status === 200 || response.status === 201) {
        return {
            success: json.success,
        };
    }
}

